import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { apiPost, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import ErrorMessage from "components/ErrorMessage";

function AreaModal({ showModal, toggleModal, item, getAllAreas }) {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { logoutUser } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [name, setName] = useState(item?.name ?? "");
  const [status, setStatus] = useState(item?.status ?? "active");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name,
        status,
      };

      let result;
      if (item?._id) {
        payload.id = item._id;
        const path = apiPath.updateArea;
        result = await apiPut(path, payload);
      } else {
        const path = apiPath.createArea;
        result = await apiPost(path, payload);
      }

      if (result?.status === 200) {
        notification.success(result?.data?.message);
        toggleModal();
        getAllAreas();
      }
    } catch (error) {
      console.log("error ", error);
      if (error.response?.status === 401 || error.response?.status === 409) {
        logoutUser();
      }
      setError(error.response?.data?.message ?? "Something went wrong");
    }
  };

  return (
    <div className="fixed inset-0 z-10 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div
          className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <form onSubmit={handleSubmit}>
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                  <h3
                    className="text-lg leading-6 font-medium text-gray-900"
                    id="modal-headline"
                  >
                    {item?._id ? t("EDIT_AREA") : t("ADD_AREA")}
                  </h3>
                  <div className="mt-2">
                    {error && <ErrorMessage message={error} />}
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("NAME")}
                      </label>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                      />
                    </div>
                    <div className="mt-4">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("STATUS")}
                      </label>
                      <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      >
                        <option value="active">{t("ACTIVE")}</option>
                        <option value="inactive">{t("INACTIVE")}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-LightBlue text-base font-medium text-white hover:bg-DarkBlue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                {t("SAVE")}
              </button>
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                onClick={toggleModal}
              >
                {t("CANCEL")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AreaModal;
